/**
 * GIWAHS Adaptive Journey — Persistence Errors (AJIP-16.02.004 · WS7)
 * ---------------------------------------------------------------------
 * Typed error hierarchy for the Persistence Framework. Every failure
 * path returns or throws one of these classes.
 *
 * All persistence errors extend the Core Engine's JourneyError so that
 * consumers of the engine's error surface (from AJIP-16.02.003) can
 * catch persistence failures without additional imports.
 */
import { JourneyError } from '../core/JourneyErrors';

class PersistenceError extends JourneyError {}
class AdapterContractError extends PersistenceError {}
class StorageUnavailableError extends PersistenceError {}
class RecordNotFoundError extends PersistenceError {}
class RecordExpiredError extends PersistenceError {}
class RecordCorruptError extends PersistenceError {}
class SchemaValidationError extends PersistenceError {}
class UnsupportedSchemaVersionError extends PersistenceError {}
class MigrationError extends PersistenceError {}
class ConflictError extends PersistenceError {}
class OwnershipError extends PersistenceError {}
class ForbiddenFieldError extends PersistenceError {}
class PayloadTooLargeError extends PersistenceError {}
class IntegrityError extends PersistenceError {}
class SavePolicyError extends PersistenceError {}

const PERSISTENCE_ERROR_TYPES = Object.freeze([
  'PersistenceError',
  'AdapterContractError',
  'StorageUnavailableError',
  'RecordNotFoundError',
  'RecordExpiredError',
  'RecordCorruptError',
  'SchemaValidationError',
  'UnsupportedSchemaVersionError',
  'MigrationError',
  'ConflictError',
  'OwnershipError',
  'ForbiddenFieldError',
  'PayloadTooLargeError',
  'IntegrityError',
  'SavePolicyError',
]);

export {
  PersistenceError,
  AdapterContractError,
  StorageUnavailableError,
  RecordNotFoundError,
  RecordExpiredError,
  RecordCorruptError,
  SchemaValidationError,
  UnsupportedSchemaVersionError,
  MigrationError,
  ConflictError,
  OwnershipError,
  ForbiddenFieldError,
  PayloadTooLargeError,
  IntegrityError,
  SavePolicyError,
  PERSISTENCE_ERROR_TYPES,
};
